import Config from '@/config'
import Constant from '@/constant'
import util from '@/util'

/**
 * Check if profile features are restricted due to basic constraints
 * @param {Object} params - Parameters object
 * @param {boolean} params.isSkoleTube - Whether presentation is from Skoletube
 * @param {boolean} params.isZoomApp - Whether app is running in Zoom
 * @returns {boolean} - True if profile features should be restricted
 */
function hasBasicRestrictions({ isSkoleTube, isZoomApp }) {
  return util.checkWhiteLabelDomain()
    || Config.region === Constant.euRegion
    || isSkoleTube
    || isZoomApp
}

/**
 * Core logic to determine if user can access profile route
 * @param {Object} params - Parameters object
 * @param {Object} params.presentation - Current presentation object
 * @returns {boolean} - True if user can access profile route
 */
function canAccessProfileRoute({ presentation }) {
  // No presentation context (route /account) - allow access for everyone (including guests to see login form)
  if (!presentation || !presentation.id) {
    return true
  }

  // For guests and participants, access depends on the presentation setting
  return presentation.isAccountTabVisible === true
}

/**
 * Check if user can access profile features (both tab visibility and route access)
 * @param {Object} params - Parameters object
 * @param {Object} params.presentation - Current presentation object
 * @param {boolean} params.isSkoleTube - Whether presentation is from Skoletube
 * @param {boolean} params.isZoomApp - Whether app is running in Zoom
 * @returns {boolean} - True if user can access profile (show tab & allow route access)
 */
export function canAccessProfile({
  presentation,
  isSkoleTube,
  isZoomApp,
}) {
  // Check basic restrictions (WhiteLabel, EU region, Skoletube, ZoomApp)
  if (hasBasicRestrictions({ isSkoleTube, isZoomApp })) {
    return false
  }

  // For both guest and logged-in users: check if they can access the profile route
  return canAccessProfileRoute({
    presentation,
  })
}
